export function getDefaultPastOrderReportFilters({ productId, locationId }) {
  return {
    product: productId,
    location: locationId,
    fulfillment_status: 'COMPLETE',
  };
}
